import globalIP from '@/GlobelIP';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Breadcrumb, Col, Container, Divider, Grid, Row, SelectPicker, Stack } from 'rsuite';
import CostingViewTable from './costingViewTable';
import ugr from '@/UGRoute';

export default function CostingViewPage() {
  const [costingFor, setCostingFor] = useState({ for: '', name: '' });
  const [buyerAllData, setBuyerAllData] = useState([]);
  useEffect(() => {
    const fetchData = async (endpoint, labelAttribute, valueAttribute) => {
      try {
        const {
          data: {
            meta: {
              pagination: { pageCount }
            }
          }
        } = await axios.get(`${globalIP}${endpoint}`);
        const requests = [];
        for (let page = 1; page <= pageCount; page++) {
          requests.push(axios.get(`${globalIP}${endpoint}?populate=*&pagination[page]=${page}`));
        }
        const responses = await Promise.all(requests);
        const data = responses
          .flatMap(response => response.data.data)
          .map(item => ({
            label: item.attributes[labelAttribute],
            value: item.attributes[valueAttribute]
          }));
        setBuyerAllData(data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData('/api/buyer-details', 'buyernm', 'buyernm');
  }, []);
  return (
    <>
      <Container className="main">
        <Stack
          className="table-toolbar"
          style={{ paddingLeft: '0', paddingBottom: 0 }}
          justifyContent="space-between"
        >
          <Stack direction="column" alignItems="flex-start">
            <h3 className="title">Costing View</h3>
            <Breadcrumb>
              <Breadcrumb.Item href={`/${ugr}/dashboard `}>Home</Breadcrumb.Item>
              <Breadcrumb.Item href={`/${ugr}/products`}>Products</Breadcrumb.Item>
              <Breadcrumb.Item href={`/${ugr}/product-Selection-Page`}>Costing Insertion</Breadcrumb.Item>
              <Breadcrumb.Item active>Costing View</Breadcrumb.Item>
            </Breadcrumb>
          </Stack>
        </Stack>
      </Container>
      <Grid fluid style={{ padding: '0 20px' }}>
        <Row>
          <Col xs={4}>
            <SelectPicker
              data={[
                { label: 'Factory', value: 'factory' },
                { label: 'Buyer', value: 'buyer' }
              ]}
              style={{ width: '100%',zIndex:1,position:"relative" }}
              value={costingFor?.for}
              onChange={value => setCostingFor(prev => ({ ...prev, for: value }))}
              searchable={false}
              placeholder="Costing For"
            />
          </Col>
          {costingFor.for == 'buyer' && (
            <Col xs={4}>
              <SelectPicker
                data={buyerAllData}
                style={{ width: '100%' }}
                searchable={false}
                placeholder="Buyer Name"
                value={costingFor?.name}
                onChange={value => setCostingFor(prev => ({ ...prev, name: value }))}
              />
            </Col>
          )}
        </Row>
      </Grid>
      <Divider style={{ margin: '10px 0 10px 0' }} />
      <main style={{ padding: '0 20px' }}>
        <CostingViewTable costingFor={costingFor}/>
      </main>
    </>
  );
}
